import Axios from "axios";
import store from "@/store";
import router from "@/router";
// import Swal from 'sweetalert2/dist/sweetalert2.js';
// import router from "@/router";



const options = {
  baseURL: process.env.VUE_APP_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

const httpClient = Axios.create(options);

httpClient.interceptors.request.use((config) => {
  if (!config.skipAuth && store.getters["authorization/getAuthToken"]) {
    config.headers["Authorization"] =
      "Bearer " + store.getters["authorization/getAuthToken"];
  }
  return config;
});

httpClient.interceptors.response.use(
    (response) => response,
    (error) => {
        try {
            if (error.response && error.response.status === 401) {
                const requestUrl = error.config?.url || ''
                const isLoginRequest = requestUrl.includes('/api/auth/login')
                const hasAuthToken = store.getters["authorization/getAuthToken"]
                
                if (!isLoginRequest && hasAuthToken) {
                    store.dispatch("authorization/refreshToken", store.state.authorization.authToken).then(() => {
                        window.location.reload();
                    });
                } else if (isLoginRequest) {
                    store.commit('authorization/CLEAR_AUTH')
                }
            }
            if (error.response && (error.response.status === 403 || error.response.status === 500)) {
                router.push('/login');
            }
        } catch (e) {
            router.push('/login').then(() => window.location.reload())
        }
        return Promise.reject(error);
    }
);

const ApiClient = {
  get(url, conf = {}) {
    return httpClient.get(url, conf);
  },

  put(url, data = {}, conf = {}) {
    return httpClient.put(url, data, conf);
  },

  delete(url, conf = {}) {
    return httpClient.delete(url, conf);
  },

  post(url, data = {}, conf = {}) {
    return httpClient.post(url, data, conf);
  },

  patch(url, data = {}, conf = {}) {
    return httpClient.patch(url, data, conf);
  },
};

export default ApiClient;

